// Ignore stored generated line_cost when previewing an edited line.
export function liveCostSheet(sheet, processDraft, processId, materialDraft, materialId) {
  const replace = (rows = [], draft, id, required) => {
    if (!draft?.[required]) return rows;
    const next = { ...draft, line_cost: undefined };
    return id ? rows.map((row) => row.id === id ? next : row) : [...rows, next];
  };
  return { ...sheet,
    process_lines: replace(sheet.process_lines, processDraft, processId, 'process_id'),
    material_lines: replace(sheet.material_lines, materialDraft, materialId, 'material_id'),
  };
}
